import React from 'react'
import { Skeleton as MuiSkeleton, SkeletonProps } from '@mui/material'

interface Props {
  components: SkeletonProps[]
}

const Skeleton: React.FC<Props> = ({ components }) => {
  return (
    <>
      {components.map((component, i) => (
        <MuiSkeleton key={i} animation="wave" variant="rectangular" {...component} />
      ))}
    </>
  )
}

export default Skeleton
